import { render, staticRenderFns } from "./UploadLocalFile.vue?vue&type=template&id=547c9c88&scoped=true&"
import script from "./UploadLocalFile.vue?vue&type=script&lang=js&"
export * from "./UploadLocalFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadLocalFile.vue?vue&type=style&index=0&id=547c9c88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c9c88",
  null
  
)

export default component.exports